import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const verification_status = {
    verified:'موثق',
    unverified:'غير موثق',
    pending:'قيد المعالجة',
}


function OrganizationModal({showModal, handleCloseModal,selectedRequest}) {


  
  return (
      <Modal show={showModal} onHide={handleCloseModal} size="lg" scrollable>
        <Modal.Header className='bg-dark'>
          <Modal.Title className='fs-5 text-white mb-0'>مقدم العريضة</Modal.Title>
          <Button variant="light" className="mb-0" size="sm" onClick={handleCloseModal} aria-label="Close"><i class="bi bi-x-lg"></i></Button>
        </Modal.Header>
        <Modal.Body>
        <div class="modal-body p-4 row g-4 justify-content-around align-items-center">

        <div className='col-md-5 bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1'>
            <h6 class="mb-3"> <i class="fas fa-building fa-fw"></i> اسم المؤسسة</h6>
            <p class="mb-3">{selectedRequest?.profile.name}</p>
          </div>

          <div className='col-md-5 bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1'>
            <h6 class="mb-3"> <i class="fas fa-building fa-fw"></i> مكان المؤسسة</h6>
            <p class="mb-3">{selectedRequest?.profile?.place}</p>
          </div>

          <div className='col-md-5 bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1'>
              <h6 class="mb-3"> <i class="fas fa-user-tie fa-fw"></i> ممثل المؤسسة</h6>
              <p class="mb-3">{selectedRequest?.profile.representative_name}</p>
          </div>
          <div className='col-md-5 bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1'>
              <h6 class="mb-3"> <i class="fas fa-table fa-fw"></i> رقم هوية ممثل المؤسسة</h6>
              <p class="mb-3">{selectedRequest?.profile.representative_id_num}</p>
          </div>
          <div className='col-md-5 bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1'>
              <h6 class="mb-3"> <i class="fas fa-phone fa-fw"></i> رقم الجوال</h6>
              <p class="mb-3 dr-ltr-right">{selectedRequest?.profile.phone_number}</p>
          </div>




          {selectedRequest?.profile.attachments?.length ? 
          <div className='col-md-8 bg-secondary bg-opacity-10  border-secondary rounded-3 p-3 pb-1'>
            <h6 class="mb-3"> <i class="fas fa-link fa-fw"></i> التزكيات والمرفقات</h6>
            {selectedRequest?.profile.attachments?.map(att => (
              <a key={att.id} className='text-dark' target='_blank' href={att.attachment}>
              <span role='button' class="mb-3 d-block hoverable-span small">{att.title} <i class="fas fa-arrow-up-right-from-square fa-fw"></i></span>
              </a>
            ))}
            
          </div>
          : null }

			</div>
        </Modal.Body>
        <Modal.Footer>
          <Button className='my-0' variant="danger-soft" onClick={handleCloseModal}>
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
  );
}
export default OrganizationModal